/**
 * Copyright 2024 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
export const getDefaultPDPCacheKey = (language: string) => ['defaultPDP', 'response', language];
